// extracted by mini-css-extract-plugin
export default {"formButtons":"ImageEnrichmentForm_formButtons__QWXNX"};